import React from "react";
import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import { Grid } from "antd";
const { useBreakpoint } = Grid;




const VideoModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow-y: hidden;
`;

const VideoPlayer = styled.video`
  /* width: 60%; */
  height: auto;
  max-height: 80%;
  object-fit: cover;
`;

const CloseButton = styled(CloseOutlined)`
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  color: white;
  z-index: 10;
  cursor: pointer;
`;

const VideoModal = ({ isVisible, onClose, videoSrc }) => {
  const screens = useBreakpoint();
  if (!isVisible) return null;
  

  return (
    <VideoModalContainer>
      <CloseButton onClick={onClose} />
      <VideoPlayer style={{width: screens.xs? "100%":"60%"}} controls autoPlay>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </VideoPlayer>
    </VideoModalContainer>
  );
};

export default VideoModal;
